
import { addPermissionsToRoute} from '@qsrsoft/myq-core';

const routes = {
  name: 'Labor',
  icon: 'mdi-timer-sand',
  path: '/reports/labor/',
  children: [
    {
      path: '/reports/labor/laborSchedules',
      name: 'Labor Schedules',
      meta: { id: 'reports-laborSchedules' },
      component: () => import('./LaborSchedules.vue'),
      ...addPermissionsToRoute(['laborSchedules']),
    },
  ]
};

export default routes;